import * as React from "react";
import { forwardRef } from "react";
const SvgSend = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 31, height: 27, viewBox: "0 0 31 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.1875 10.5833L0.202083 0.375L30.8125 13.5L0.202083 26.625L0.1875 16.4167L22.0625 13.5L0.1875 10.5833ZM3.11865 4.79375L14.0707 9.48958L3.10407 8.03125L3.11865 4.79375ZM14.0562 17.5104L3.10407 22.2062V18.9687L14.0562 17.5104Z", fill: "black", fillOpacity: 0.54 }));
const ForwardRef = forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
